<div class="transaction-general-dialog">
  <div class="transaction-header">{{ 'Transaction_Dialog_1' | t }}</div>

  <div class="transaction-activity-container">
    <div class="transaction-activity-row">
      <div class="left">{{ 'Transaction_Dialog_2' | t }}</div>
      <div class="right">{{ Deposit | number : '1.2-2' }} €</div>
    </div>
    <div class="transaction-activity-row">
      <div class="left">{{ 'Transaction_Dialog_3' | t }}</div>
      <div class="right">{{ TotalBet | number : '1.2-2' }} €</div>
    </div>
  </div>
  <div class="transaction-info-container">
    <div class="transaction-info-row">{{ 'Transaction_Dialog_4' | t }}</div>
    <div class="transaction-info-row">{{ 'Transaction_Dialog_5' | t }}</div>
    <div class="transaction-info-row">
      <span>
        {{ 'Transaction_Dialog_6' | t }} <a href="https://www.bzga.de/" target="_blank">{{ 'Transaction_Dialog_7' | t }}</a>
      </span>
    </div>
  </div>
  <div class="lower-info-container">
    <span>
      <ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
        <span *ngSwitchCase="'wettarena'"> {{ 'Transaction_Dialog_8' | t }} {{ 'Transaction_Dialog_9' | t }} {{ 'Transaction_Dialog_14' | t }} </span>
        <span *ngSwitchCase="'b500'"> {{ 'Transaction_Dialog_10' | t }} {{ 'Transaction_Dialog_11' | t }} {{ 'Transaction_Dialog_14' | t }} </span>
        <span *ngSwitchDefault> {{ 'Transaction_Dialog_12' | t }} {{ 'Transaction_Dialog_13' | t }} {{ 'Transaction_Dialog_14' | t }} </span>
      </ng-container>
    </span>
  </div>
  <div class="white-black-text confirm-button border-black" (click)="goToHome()">
    <div class="btn-text">
      {{ 'Confirm_SettingsConsent' | t }}
    </div>
  </div>
</div>
